module.exports = __webpack_public_path__ + "static/media/icons_Bilan Hanche.2b922332.svg";